import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

import AQIcon from '@/components/shared/interactions/AQIcon.vue';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'AQButton',
  props: {
    primary: { type: Boolean },
    outlined: { type: Boolean },
    basic: { type: Boolean },
    color: {},
    disabled: { type: Boolean },
    loading: { type: Boolean },
    prependIcon: {},
    size: {},
    icon: {},
    iconSize: {},
    variant: {},
    height: {},
    border: {}
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, _mergeProps(_ctx.$attrs, {
    color: props.disabled ? 'aquassistGray1' : props.color,
    disabled: props.disabled,
    loading: props.loading,
    "prepend-icon": props.prependIcon,
    size: props.size,
    variant: props.variant,
    height: props.height,
    icon: !!props.icon,
    border: props.border
  }), {
    default: _withCtx(() => [
      (props.icon)
        ? (_openBlock(), _createBlock(AQIcon, {
            key: 0,
            name: props.icon,
            size: __props.iconSize
          }, null, 8, ["name", "size"]))
        : _renderSlot(_ctx.$slots, "default", { key: 1 })
    ]),
    _: 3
  }, 16, ["color", "disabled", "loading", "prepend-icon", "size", "variant", "height", "icon", "border"]))
}
}

})